import React, { useState, useEffect } from "react";
import classes from "./DenMap.module.css";
import coordinates from "../../Assets/Data/DenMap1.json";
import { useTranslation } from 'react-i18next';
import PlaceName from "../../Util/PlaceName";
import DenImg from "../../Assets/Images/DenMisc/inactive_den.png";
import ActiveDenImg from "../../Assets/Images/DenMisc/active1_den.png";
import ActiveDen2Img from "../../Assets/Images/DenMisc/active2_den.png";
import DenLocations from "../../Assets/Data/DenLocations_WA.json";
import NestMapping from "../../Assets/Data/JapEn.json";
import denNestMapping from "../../Assets/Data/Nests";

import {getCommonNest} from "../../Util/NestUtil";
import MiniEntry from "./MiniEntry";
import { Link } from "react-router-dom";
import Footer from "./Footer";

const areaClasses = [
    classes.BigMapLocation0, classes.BigMapLocation1, classes.BigMapLocation2, classes.BigMapLocation3, classes.BigMapLocation4, 
    classes.BigMapLocation5, classes.BigMapLocation6, classes.BigMapLocation7, classes.BigMapLocation8, classes.BigMapLocation9, 
    classes.BigMapLocation10, classes.BigMapLocation11, classes.BigMapLocation12, classes.BigMapLocation13, classes.BigMapLocation14, 
    classes.BigMapLocation15, classes.BigMapLocation16,
    classes.BigMapLocation17, classes.BigMapLocation18, classes.BigMapLocation19, classes.BigMapLocation20, classes.BigMapLocation21, 
    classes.BigMapLocation22, classes.BigMapLocation23, classes.BigMapLocation24, classes.BigMapLocation25, classes.BigMapLocation26, 
    classes.BigMapLocation27, classes.BigMapLocation28, classes.BigMapLocation29, classes.BigMapLocation30, classes.BigMapLocation31
]

const areaDetailedClasses = [
    classes.DetailedMap0, classes.DetailedMap1, classes.DetailedMap2, classes.DetailedMap3, classes.DetailedMap4, 
    classes.DetailedMap5, classes.DetailedMap6, classes.DetailedMap7, classes.DetailedMap8, classes.DetailedMap9, 
    classes.DetailedMap10, classes.DetailedMap11, classes.DetailedMap12, classes.DetailedMap13, classes.DetailedMap14, 
    classes.DetailedMap15, classes.DetailedMap16,
    classes.DetailedMap17, classes.DetailedMap18, classes.DetailedMap19, classes.DetailedMap20, classes.DetailedMap21, classes.DetailedMap22, 
    classes.DetailedMap23, classes.DetailedMap24, classes.DetailedMap25, classes.DetailedMap26, classes.DetailedMap27, classes.DetailedMap28, 
    classes.DetailedMap29, classes.DetailedMap30, classes.DetailedMap31]

const bigMapClasses = [classes.BigMap0, classes.BigMap1];
const buttonClass = [classes.ButtonInactive, classes.ButtonActive];

const rowClasses = [classes.Sword, classes.Shield, classes.Both];

const startValues = [0, 17];
const endValues = [16, 31];

const DenMap = props => {
    // eslint-disable-next-line
    const [t, i18n] = useTranslation();
    const [selectedClass, setSelectedClass] = useState(17);
    const [activeDen, setActiveDen] = useState([0, 0]);
    const [activeNest, setActiveNest] = useState([]);
    const [activeNestIdx, setActiveNestIdx] = useState([]);
    const [currentArea, setcurrentArea] = useState(1);

    useEffect(() => {
        activeNestHandler(selectedClass, activeDen[0], activeDen[1]);
    // eslint-disable-next-line
    }, [])

    const clickHandler = event => {
        const base = event.target.getBoundingClientRect();
        const [x,y] = [Math.floor(event.clientX - base.x), Math.floor(event.clientY - base.y)]
        for(var i = startValues[currentArea]; i <= endValues[currentArea]; i++) {
            const coords = coordinates[i];
            for(var k = 0; k < coords.length; k++) {
                if(x === coords[k][0] && y === coords[k][1]) {
                    setSelectedClass(i);
                    setActiveDen([0, 0]);
                    activeNestHandler(i, 0, 0);
                }
            }
        }
    }

    const activeNestHandler = (area, idx, active) => {
        const den = NestMapping[area][idx];
        const nest = getCommonNest(denNestMapping[den][active]-1);
        setActiveNest(nest);
        setActiveNestIdx(denNestMapping[den][active])
    }

    const activateDen = idx => {
        if(activeDen[0] === idx) {
            if(activeDen[1] === 0) {
                setActiveDen([idx, 1]);
                activeNestHandler(selectedClass, idx, 1);
            } else {
                setActiveDen([idx, 0]);
                activeNestHandler(selectedClass, idx, 0);
            }
        } else {
            setActiveDen([idx, 0]);
            activeNestHandler(selectedClass, idx, 0);
        }
    }

    const detailClickHandler = event => {
        const base = event.currentTarget.getBoundingClientRect();
        const [x,y] = [Math.floor(event.clientX - base.x), Math.floor(event.clientY - base.y)]
        Object.values(DenLocations[selectedClass]).map((v, i) => {
            if(v[0] <= x && x < v[0] + 25 && v[1]<= y && y < v[1] + 25) {
                activateDen(i);
            }
            return null;
        });
    }

    const changeAreaHandler = idx => {
        setcurrentArea(idx);
        setSelectedClass(startValues[idx]);
        setActiveDen([0, 0]);
        activeNestHandler(startValues[idx], 0, 0);
    }

    return (
        <>
        <div className={classes.ButtonOverlay}>
            <button onClick={() => changeAreaHandler(0)} className={buttonClass[currentArea === 0 ? 1 : 0]}>{t("wildareas.0")}</button>
            <button onClick={() => changeAreaHandler(1)} className={buttonClass[currentArea === 1 ? 1 : 0]}>{t("wildareas.1")}</button>
        </div>
        <div className={classes.overallWrapper}>
    <h1>{t("wildareas." + currentArea)}: <PlaceName id={selectedClass}/> (Den {NestMapping[selectedClass][activeDen[0]] + 1 - (NestMapping[selectedClass][activeDen[0]] >= 100 ? 100 : 0)})</h1>
        <div className={classes.Container}>
            <div className={bigMapClasses[currentArea]}>
                <div className={areaClasses[selectedClass]} onClick={clickHandler} />
            </div>
            <div className={classes.DetailedMapCommon}><div className={classes.DetailMapMobile}>
            <div className={areaDetailedClasses[selectedClass]} onClick={detailClickHandler}>
                {
                    Object.keys(DenLocations[selectedClass]).map((v, i) => {
                        const val = DenLocations[selectedClass][v];
                        const im = activeDen[0] === i ? activeDen[1] === 0 ? ActiveDenImg : ActiveDen2Img : DenImg;
                        const left = val[0] - 20;
                        return <img src={im} key={i} alt="Den Map" width="15%" style={{"position": "absolute", "left": Math.floor(left*100/520) + "%", "bottom": Math.floor((390 - val[1] - 21)*100/390) + "%"}} />//onClick={event => activateDen(i)}
                    })
                }
            </div>
            </div>
            </div>
            <div className={classes.ContentTable}>
            <h2><Link to={/dens/ + activeNestIdx} className={classes.Unstyled}>{t("misc:NEST")} {activeNestIdx}</Link></h2>
            <div className={classes.Break} />
            <div className={classes.MonWrapper}>
                {
                    activeNest.map((entry, idx) => <MiniEntry key={idx} cssClass={rowClasses[entry.game]} data={entry}/>)
                }
            </div>
            </div>
        </div>
        </div>
        <Footer />
        </>
    );
}

export default DenMap;